<template>
<div class="content">
    <!-- start banner -->
    <div id="banner-part" class="subbanner">
        <div class="container max-1762">
            <div class="row">
                <div class="col column-left">
                </div>
                <div class="col column-right">
                    <div class="overlay">
                        <div class="megatitle-sub"><h2>Contact</h2></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end banner -->
    
    <!-- start content -->
    <div id="content-part">
    
        <!-- start megapanel-bar -->
        <div class="megapanel-bar maincontact-bar">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="inner">
                            <div class="row row-reverse mrg0">
                                <div class="col-6 pad0">
                                    
                                    <div class="map" id="googleMap"></div>
                                    <!-- <div class="map" style="background: url(./images/map.png)no-repeat center/cover;"></div> -->
                                </div>
                                <div class="col-6 pad0">
                                    <div class="addresspanel">
                                        <h2>Ons kantoor</h2>
                                        <address>
                                            Weena 505<br/>
                                            3013 AL Rotterdam <br/>
                                            The Netherlands <br/><br/>

                                            <a :href="'mailto:' + this.$mirzacles.email">{{this.$mirzacles.email}}</a><br/><br/>

                                            HR Department:<br/>
                                            <a :href="'tel:' + this.$mirzacles.phone">{{this.$mirzacles.phone}}</a>
                                        </address>
                                    </div>
                                </div>
                            </div>
                            <div class="row mrg0">
                                <div class="col-6 pad0">
                                    <figure class="figure-1"></figure>
                                </div>
                                <div class="col-6 pad0">
                                    <form :action="this.$mirzacles.contactEndPoint" @submit="submitContactForm" method="POST" class="megaform gform">
                                        <div class="row">
                                            <div class="input-group col-12">
                                                <h2>Neem contact op</h2>
                                                <p>Heb je vragen of wil je gewoon even Hallo zeggen?</p>
                                                <p>Neem contact met ons op door dit formulier in te vullen en we zullen zo snel mogelijk reageren.</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-group col-12">
                                                <span class="invalid-feedback"></span>
                                                <input type="text" name="honeypot" class="d-none">
                                                <input type="text" class="inputtext" name="name" placeholder="Naam*">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-group col-6">
                                                <span class="invalid-feedback"></span>
                                                <input type="text" class="inputtext" name="phone" placeholder="Telefoonnummer">
                                            </div>
                                            <div class="input-group col-6">
                                                <span class="invalid-feedback"></span>
                                                <input type="text" class="inputtext" name="email" placeholder="E-Mailadres*">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-group col-12">
                                                <span class="invalid-feedback"></span>
                                                <input type="text" class="inputtext" name="subject" placeholder="Onderwerp*">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-group col-12">
                                                <span class="invalid-feedback"></span>
                                                <textarea type="text" class="inputtext" name="message" placeholder="Bericht*"></textarea>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="bg-black">
                                                    <button type="submit" id="send-btn" class="primarybtn">
                                                        <div class="loader-container">
                                                            <div class="typing_loader"></div>
                                                        </div>
                                                        Verzenden
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <div id="success">
                                        <div class="row">
                                            <div class="col-12">
                                                <h2>Gedaan!</h2>
                                                <p>Bedankt voor je bericht. Je krijgt binnen 2 werkdagen reactie van ons!</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ends megapanel-bar -->

    </div>
    <!-- end content -->
</div>
</template>

<style scoped>
.figure-1{
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('../assets/images/img-6.jpeg');
}

#success {
	padding: 32px;
    background: #fcc530;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	transform: translateY(100%);
	transition: transform .4s ease;
}
#success.show {
	transform: translateY(0);
}

.loader-container {
	position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
	align-items: center;
	transform: scale(1.7);
	opacity: 0;
	transition: all .3s ease;
}
.typing_loader {
    width: 6px;
    height: 6px;
    border-radius: 50%;
	animation: typing 1s linear infinite alternate;
    position: relative;
    left: -12px;
}
#send-btn.busy{
	position: relative;
	color: #161616;
}
#send-btn.busy::after {
	margin-left: 16px;
	opacity: 0;
}

#send-btn.busy .loader-container {
	transform: scale(1.7);
	opacity: 1;
}

@keyframes typing{
   	0%{
        background-color: rgba(255,255,255, 1);
        box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                    24px 0px 0px 0px rgba(255,255,255,0.2);
	}
    25%{ 
        background-color: rgba(255,255,255, 0.4);
        box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                    24px 0px 0px 0px rgba(255,255,255,0.2);
    }
    75%{ background-color: rgba(255,255,255, 0.4);
        box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                    24px 0px 0px 0px rgba(255,255,255,1);
	}
}
</style>

<script>
import axios from 'axios';
import gmapsInit from '../utils/gmaps';

export default {
    methods: {// get all data in form and return object
        getFormData(form) {
            const elements = form.elements;
            let honeypot;

            const fields = Object.keys(elements).filter(function(k) {
                if (elements[k].name === "honeypot") {
                    honeypot = elements[k].value;
                    return false;
                }
                return true;
            }).map(function(k) {
                if(elements[k].name !== undefined) {
                    return elements[k].name;
                // special case for Edge's html collection
                }else if(elements[k].length > 0){
                    return elements[k].item(0).name;
                }
            }).filter(function(item, pos, self) {
                return self.indexOf(item) == pos && item;
            });

            let formData = {};
            fields.forEach(function(name){
                const element = elements[name];
                
                // singular form elements just have one value
                formData[name] = element.value;

                // when our element has multiple items, get their values
                if (element.length) {
                    let data = [];
                    for (let i = 0; i < element.length; i++) {
                        let item = element.item(i);
                        if (item.checked || item.selected) {
                            data.push(item.value);
                        }
                    }
                    formData[name] = data.join(', ');
                }
            });

            // add form-specific values into the data
            formData.formDataNameOrder = JSON.stringify(fields);
            formData.formGoogleSheetName = form.dataset.sheet || "responses"; // default sheet name
            formData.formGoogleSend = form.dataset.email || ""; // no email by default

            return {data: formData, honeypot: honeypot};
        },
        submitContactForm(e) {
            e.preventDefault();
            console.log('submitted');
            
            const formData = this.getFormData(e.target);
            const data = Object.keys(formData.data).map(function(k) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(formData.data[k]);
            }).join('&');

            const requiredFields = ['name', 'email', 'subject', 'message'];

            requiredFields.forEach(field => {
                const input = document.querySelector(`[name="${field}"]`);
                input.classList.remove('is-invalid');
                input.closest('.input-group').querySelector('.invalid-feedback').classList.add('d-none');
            });

            let emptyFields = [];
            requiredFields.forEach(field => {
                if (!formData.data.hasOwnProperty(field) || !formData.data[field]) {
                    emptyFields.push(field);
                }
            });
            if (emptyFields.length) {
                emptyFields.forEach(field => {
                    const input = document.querySelector(`[name="${field}"]`);
                    input.classList.add('is-invalid');
                    const warning = input.closest('.input-group').querySelector('.invalid-feedback');
                    warning.classList.remove('d-none');
                    warning.innerText = 'Dit veld is verplicht';
                });

                return;
            }

            // If a honeypot field is filled, assume it was done so by a spam bot.
            if (formData.honeypot) {
                return false;
            }

            document.querySelector('#send-btn').disabled = true;
			document.querySelector('#send-btn').classList.add('busy');
            
            axios.post(e.target.action, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
                .then(res => {
                    console.log(res)
                    if (res.data.result == "success") {
                        document.querySelector('#success').classList.add('show');
                    }
                })
                .catch(err => console.error(err));

        }
    },
    async mounted() {
        try {
            const google = await gmapsInit();
            const map = new google.maps.Map(document.querySelector('#googleMap'), {
                center: { lat: 51.923785, lng: 4.472066 },
                zoom: 15
            });
            const locations = [
                {
                    position: { lat: 51.923785, lng: 4.472066 }
                }
            ];
            const markers = locations.map(x => new google.maps.Marker({...x, map})); 

        } catch (error) {
            console.error(error);
        }
    }
}
</script>